import { render } from "./ContactuspageCom.vue?vue&type=template&id=2ca988b0&scoped=true"
import script from "./ContactuspageCom.vue?vue&type=script&lang=js"
export * from "./ContactuspageCom.vue?vue&type=script&lang=js"

import "./ContactuspageCom.vue?vue&type=style&index=0&id=2ca988b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca988b0"]])

export default __exports__